<template>
  <div>
      <fzg-home-pc v-if="isPc()"
        :fz-team-list="fz_team_list"
        :fz-deal-list="fz_deal_list"
        :fz-article-list="fz_article_list"/>
      <fzg-home-mobile
        :fz-team-list="fz_team_list"
        :fz-deal-list="fz_deal_list"
        :fz-article-list="fz_article_list"
        v-else/>
  </div>
</template>
<script>

import FzgHomePc from './FzgHomePc.vue'
import FzgHomeMobile from './FzgHomeMobile.vue'
import util from '@/assets/js/util'

export default{
    components:{
      FzgHomePc,
      FzgHomeMobile,
    },
    mixins: [],
    data() {
      return {
        fz_team_list: [],
        fz_deal_list: [],
        fz_article_list: [],
      }
    },
    mounted() {
      // this.getTeamList()
      // this.getDealList()
      // this.getViewPointList()
    },
    methods: {
      isPc() {
        return util.isPc()
      },
        getTeamList() {
          var self = this
          util.resource({
              url: '/api/fz_team_list/',
              method: 'get',
              success (res) {
                if (res.code == 200) {
                  self.fz_team_list = res.data.fz_team
                }
              }
          })
        },
        getDealList() {
          var self = this
          util.resource({
              url: '/api/fz_deal_list/',
              method: 'get',
              success (res) {
                if (res.code == 200) {
                  self.fz_deal_list = res.data.fz_deal
                }
              }
          })
        },
        getViewPointList() {
          var self = this
          util.resource({
              url: '/api/fz_article_list/',
              method: 'get',
              success (res) {
                if (res.code == 200) {
                  self.fz_article_list = res.data.fz_article
                }
              }
          })
        }
    }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// FzgHome.vue?54a6f1e8